import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';
import {useContacts} from '../hooks/useContacts';
import {useContactsSelection} from '../hooks/useContactsSelection';

export const DeleteRecordButton = () => {
    const {deleteRecords} = useContacts();
    const {selection, handleClearSelection} = useContactsSelection();

    const recordIds = Object.keys(selection);
    let disabled = true;
    if (recordIds.length > 0) {
        disabled = false;
    }

    return (
        <DeleteRecordsConfirmationButton
            disabled={disabled}
            recordIdsLength={recordIds.length}
            handleConfirm={() => {
                deleteRecords();
                handleClearSelection();
            }}
        />
    );
};
